module.exports = __webpack_public_path__ + "img/awm10cm.20466d47.jpg";